import React from 'react'
import { Header, HTMLText, Button, OverlineText, Stack } from '@crossfit/ui'

import { Link } from 'pages/Programming/types'
import style from './style.module.css'

type Props = {
  bodyText: string
  link: Link
  subheading: string
}

function MonthlyFocus({ subheading, bodyText, link }: Props) {
  return (
    <Stack
      direction={['horizontal', 'vertical']}
      spacing={[6, 4]}
      className={style.wrapper}
    >
      <div>
        <Header size='medium' mb={[4, 6]} as='h4'>
          Monthly Focus
        </Header>
        <OverlineText size='medium' mb={3}>
          {subheading}
        </OverlineText>
        <HTMLText>{bodyText}</HTMLText>
      </div>
      <div className={style.buttonContainer}>
        <Button as='a' href={link.url} target='_blank' rel='noreferrer'>
          {link.text}
        </Button>
      </div>
    </Stack>
  )
}

export default MonthlyFocus
